import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const BootSize = ({ bootSize }: SpecProps<"boot_size">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (bootSize == null || bootSize === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.boot_size",
    message: "Boot size",
    comment: "Field for 'boot size' in cubic meter for construction, bus and truck in ad specification",
  });

  return <FieldValuePair field={field} value={`${formatNumber(bootSize, locale)} m`} sup={"3"} />;
};
